<template>
  <div class="news-detail-wrapper" v-if="detaildata">
    <Video :detail="detaildata" :class="isShow ? 'isShow' : ''" />
    <Atlas v-if="detaildata.imageSet" />
    <div class="news-content" v-if="!detaildata.imageSet">
      <div class="news-top">
        <h3 class="news-title">{{detaildata.title}}</h3>
        <p class="news-time">
          <!-- <span v-if="detaildata.publishTime">{{detaildata.publishTime | time}}</span> -->
          <span v-if="detaildata.publishTime">{{detaildata.publishTimeStr}}</span>
          <i v-if="detaildata.source">{{$tc('channel.source')}}{{detaildata.source}}</i>
        </p>
      </div>
      <div class="content">
        <!-- <div class="content-inner" v-html="detaildata.brief"></div> -->
        <div class="content-inner" v-html="detaildata.content"></div>
        <p class="author" v-if="detaildata.author">({{$tc('channel.author')}}{{detaildata.author}})</p>
      </div>
    </div>
  </div>
</template>

<script>

import Moment from 'moment'

import Video from './Video.vue'
import Atlas from './NewsAtlas.vue'

export default {
  name: 'NewsDetail',
  props: ['detaildata'],
  data () {
    return {
      isShow: false
    }
  },
  components: {
    Video,
    Atlas
  },
  filters: {
    time (times) {
      // return Moment(times).format('YYYY-MM-DD HH:mm')
      return Moment(times).format('YYYY-MM-DD')
    }
  },
  beforeDestroy () {
    this.isShow = true
  }
}
</script>

<style lang="scss" scoped>
.news-content {
  padding: 4.63vw 3.704vw;
  .news-top {
    // border-bottom: 1px solid #ECF2F5;
    overflow: hidden;
    margin-bottom: 3.889vw;
  }
  .news-title {
    font-size: 5.185vw;
    line-height: 1.4;
    color: #000;
    margin-bottom: 3.704vw;
    // word-wrap: break-word;
    // word-break: break-word;
    word-break: break-all;
  }
  .news-time {
    color: #7e8998;
    font-size: 3.241vw;
    line-height: 1.4;
    margin-bottom: 2.407vw;
    display: flex;
    span {
      flex-shrink: 0;
    }
    i {
      overflow: hidden;
      color: #000;
      font-style: normal;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 1.852vw;
    }
  }
  .content {
    font-size: 16px;
    word-break: break-all;
    min-height: 70vw;

    img {
      max-width: 100%;
      width: auto;
    }
    .author {
      color: #444;
      font-size: 15px;
      line-height: 1.4;
      margin-top: 6px;
    }
  }
}
.isShow {
  display: none;
  visibility: 0;
}
.content-inner {
  ::v-deep.article-body {
    p {
      width: 100% !important;
      text-indent: 0em !important;
    }
  }
}

::v-deep {
  /* 视频标签 */
  .video_ai_tag_box {
    position: absolute;
    left: .7882rem;
    bottom: 32px;
    background-color: rgba(84,94,103,0.9);
    padding: .1478rem .3448rem;
    border-radius: .2217rem;
      max-width: 17.2414rem;
    max-height: 4.4335rem;
    overflow-y: auto;
    z-index: 10;
    font-family: Arial, Helvetica, sans-serif;
  }
  .ai_tags_info {
      display: none;
  }
  .ai_tag {
    font-size: .6404rem;
    color: #FFFFFF;
    line-height: 1.46;
    text-align: left;
    font-weight: 500;
  }
  .ai_tips_box {
    display: flex;
    gap: .3695rem;
    align-items: center;
  }
  .ai_tags_tips {
    font-weight: 500;
    font-size: .6404rem;
    color: #FFFFFF;
    line-height: 1.46;
  }
  .ai_tags_arrow {
    width: .4433rem;
    height: .4433rem;
    display: block;
    background: url('https://wapcdn.chuanbaoguancha.cn/cdn/cbgc/static/img/ai_tags_arrow.png') no-repeat center center;
    background-size: 100% auto;
  }
  .video-cover-layer .video_ai_tag_box {
      bottom: 6.4039rem;
  }
  .iPhoneX .video-cover-layer .video_ai_tag_box {
      bottom: 7.497233rem;
  }
  /* 重置一下视频样式 */
  .video-js, .video-js button, .video-js video, .video-js .vjs-menu-item {
      outline: none !important;
  }
  .video-js button {
      appearance: none;
  }
  .video-details-inner .video-js p, .video-details-inner .video-js span, .details .video-js p, .details .video-js span {
      margin-bottom: 0 !important;
      line-height: inherit !important;
      font-size: inherit !important;
  }
  .video-js.vjs-fullscreen video {
      max-height: none !important;
  }
}

</style>
